import React from 'react';
import { t } from 'Src/i18n';
import { FilterWhen } from 'Components/widgets/criteria/criteria-when/filter-when/FilterWhen';
import moment from 'moment';
import type { CriteriaForSearch } from 'Components/widgets/booking-breadcrumb/EditCriteria.utils';
import 'Components/widgets/booking-breadcrumb/EditCriteria.utils';
type CriteriaDatesSelectorContentProps = {
  newCriteria: CriteriaForSearch;
  setNewCriteria: (arg0: CriteriaForSearch) => void;
  i18n: CMSContent;
};
export const CriteriaDatesSelectorContent = ({
  newCriteria,
  setNewCriteria,
  i18n,
}: CriteriaDatesSelectorContentProps) => {
  const dateFormat = t('booking.priceDetails.packagePrice.dateFormat');
  return (
    <div className="text-black">
      <FilterWhen
        openCalendarToDate={newCriteria.departure.date}
        isSubmittable={false}
        optionsDuration={i18n.faceting.when.durations}
        openingDates={newCriteria.search.openingDates}
        duration={newCriteria.departure.duration}
        departureDate={newCriteria.departure.date}
        dateFormat={dateFormat}
        changeDepartureDate={(date) => {
          if (date) {
            setNewCriteria({
              ...newCriteria,
              departure: {
                date: moment(date),
                duration: null,
              },
            });
          }
        }}
        changeTripDuration={(duration) => {
          if (duration) {
            setNewCriteria({
              ...newCriteria,
              departure: { ...newCriteria.departure, duration: duration },
            });
          }
        }}
        offsetCalendar={newCriteria.search.offsetSell}
      />
    </div>
  );
};
